import type { IconData } from '@stacksjs/iconify-core'

export const basicUiDeleteUser: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M6.5 12c0 .706.133 1.38.375 2H0a7 7 0 0 1 4.812-6.651a4 4 0 1 1 5.42-.992c-.283.387-.682.657-1.081.927q-.207.137-.406.282A5.5 5.5 0 0 0 6.5 12\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M16 12a4 4 0 1 1-8 0a4 4 0 0 1 8 0m-2-.94L12.94 10l-.94.94l-.94-.94L10 11.06l.94.94l-.94.94L11.06 14l.94-.94l.94.94L14 12.94l-.94-.94z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicUiDeleteUser
